/**
 * Generates a consistent pastel HSL background color from a string (e.g. initials or email).
 * Matches the algorithm used by MyAvatar for the logged-in user's profile picture.
 */
export function avatarPastelColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash = hash & hash; // convert to 32-bit integer
  }
  const hue = Math.abs(hash) % 360;
  const saturation = 20 + (Math.abs(hash) % 40); // 40–80%
  const lightness = 70 + (Math.abs(hash) % 25); // 70–95%
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
